module.exports = __webpack_public_path__ + "static/headerRightBg-0fa6342a4d7b119ec8dde3d7eaecacb9.png";